define('shared/util/adyen/addScript',[
    '$',
    'Promise',
    './getEnv'
], function (
    $,
    Promise,
    getEnv
) {
    var ADYEN_SCRIPT_LIVE = 'https://checkoutshopper-live.adyen.com/checkoutshopper/assets/js/sdk/checkoutSDK.1.9.2.min.js';
    var ADYEN_SCRIPT_TEST = 'https://checkoutshopper-test.adyen.com/checkoutshopper/assets/js/sdk/checkoutSDK.1.9.2.min.js';

    var loadedScript = {};
    function addScript(src) {
        if (loadedScript[src]) {
            return loadedScript[src];
        }

        loadedScript[src] = new Promise(function(rs){
            $.getScript(src, rs);
        });
        return loadedScript[src];
    }

    return function () {
        return getEnv()
            .then(function (env) {
                if (
                    env === 'live'
                ) {
                    return addScript(ADYEN_SCRIPT_LIVE);
                } else {
                    return addScript(ADYEN_SCRIPT_TEST);
                }
            });
    };
});
